import magnifiAPIInstance from "./apiInstance";
export const channelSummaryAPIs = {
  getHealthMetrics: (payload) => magnifiAPIInstance.post("/medialive/health-logs", payload),
  getHealthAlerts: (payload) => magnifiAPIInstance.post("/get-medialive/health-alerts", payload),
};
